import React from "react";
import styled from "styled-components";
import { arrayOf, func, object as obj, string } from "prop-types";
import ErrorMessage from "components/onboarding/components/OnboardingErrorMessage";
import downchevronlightgrey from "icons/down-chevron-grey.svg";

const Select = styled.select`
  padding: 10px 35px 10px 10px;
  margin: 5px 0;
  font-size: 0.8rem;
  font-family: "Source Sans Pro", sans-serif;
  border: 2px solid
    ${({ error, theme }) =>
      error ? theme.colors.statusRed : theme.colors.grey};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url(${downchevronlightgrey}) no-repeat;
  background-position: 95%;
  background-size: 20px auto;
  border-radius: 5px;
  color: ${({ selected, theme }) =>
    selected ? theme.colors.darkBlue : theme.colors.midGrey};
  min-width: 250px;
  width: ${({ width }) => width};

  &:active,
  &:focus,
  &:visited,
  &:hover {
    outline: none;
  }
`;

const OnboardingSelect = ({
  className,
  error,
  name,
  onChange,
  options,
  placeholder,
  value,
  width
}) => (
  <div>
    <Select
      className={className}
      error={error}
      name={name}
      onChange={onChange}
      selected={value}
      value={value}
      width={width}
    >
      <option default value="">
        {placeholder}
      </option>
      {options.map(taxon => (
        <option key={taxon.taxon_id} value={taxon.taxon_id}>
          {taxon.value}
        </option>
      ))}
    </Select>
    {error && <ErrorMessage error={error} />}
  </div>
);

OnboardingSelect.propTypes = {
  className: string,
  error: string,
  name: string.isRequired,
  onChange: func.isRequired,
  options: arrayOf(obj).isRequired,
  placeholder: string,
  value: string.isRequired,
  width: string
};

export default OnboardingSelect;
